import { Routes } from "@angular/router";
import { AuthGuard } from "./services/auth.guard.service";

export const routes: Routes = [
  {
    path: "home",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./views/home/home.routes").then((m) => m.routes),
  },
  {
    path: "login",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./views/login/login.page").then((m) => m.LoginPage),
  },
  {
    path: "clients",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./views/clients/clients.page").then((m) => m.ClientsPage),
  },
  {
    path: "photo-editor",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./views/photo-editor/photo.editor.page").then(
        (m) => m.PhotoEditorPage,
      ),
  },
  {
    path: "inspection",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./views/inspection/inspection.page").then(
        (m) => m.InspectionPage,
      ),
  },
  {
    path: "message",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("./views/message/message.page").then((m) => m.MessagePage),
  },
  {
    path: "**",
    redirectTo: "login",
  },
];
